import { MdCreditCard } from "react-icons/md";
import ActionButtons from "../Components/ActionButtons";
import Header from "../Components/Header";
import Layout from "../Components/Layout";

function View({ translate, onNext, onBack }) {
  return (
    <Layout>
      <Header
        subtitle={
          translate?.HEADER?.SUBTITLE || "Paiement de la première cotisation"
        }
        title={
          translate?.HEADER?.TITLE ||
          "Nous vous débiterons seulement la 1ère cotisation"
        }
        highlight={translate?.HEADER?.HIGHLIGHT || "1ère cotisation"}
      />

      <div className="acoris-payment">
        <div className="acoris-payment__grid">
          <div className="acoris-payment__field acoris-payment__field--card">
            <label className="acoris-payment__label">
              {translate?.FORM?.CARD_NUMBER?.LABEL || "Numéro de carte"}
            </label>
            <div className="acoris-payment__input-wrapper">
              <MdCreditCard size={20} className="acoris-payment__input-icon" />
              <input
                type="text"
                inputMode="numeric"
                className="acoris-payment__input"
                placeholder={
                  translate?.FORM?.CARD_NUMBER?.PLACEHOLDER ||
                  "1234 5678 9012 3456"
                }
              />
            </div>
          </div>

          <div className="acoris-payment__field">
            <label className="acoris-payment__label">
              {translate?.FORM?.EXPIRY?.LABEL || "Date d'expiration"}
            </label>
            <div className="acoris-payment__input-wrapper">
              <input
                type="text"
                inputMode="numeric"
                className="acoris-payment__input"
                placeholder={translate?.FORM?.EXPIRY?.PLACEHOLDER || "MM / AA"}
              />
            </div>
          </div>

          <div className="acoris-payment__field acoris-payment__field--cvc">
            <label className="acoris-payment__label">
              {translate?.FORM?.CVV?.LABEL || "CVC"}
            </label>
            <div className="acoris-payment__input-wrapper">
              <input
                type="text"
                inputMode="numeric"
                className="acoris-payment__input"
                placeholder={translate?.FORM?.CVV?.PLACEHOLDER || "ex : 123"}
              />
            </div>
          </div>
        </div>

        <ActionButtons
          onNext={onNext}
          onBack={onBack}
          nextText={translate?.BUTTON?.PAY || "Payer"}
          backText={translate?.BUTTON?.BACK || "Retour"}
          infoText={translate?.SECURE_NOTICE}
        />
      </div>
    </Layout>
  );
}

export default View;
